import { setStore } from "@/utils/storage";

export const setToken = (state, data) => {
  state.token = data;
  setStore("token", data);
};

export const setUserInfo = (state, data) => {
  state.userInfo = data;
  setStore("userInfo", JSON.stringify(data));
};

export const setRoleId = (state, data) => {
  state.roleId = data;
  setStore("roleId", data);
};

export const ROUTER_EVERY_LEVEL = (state, data) => {
  state.routerEveryLevel = data;
  setStore("routerEveryLevel", JSON.stringify(data));
};
export const setIsLogin = (state, data) => {
  state.isLogin = data;
  setStore("isLogin", data);
};
